<div class="title">global settings</div>
<div class="settings-options-container">
  <ng-container *ngIf="userConfigForm$ | async as userConfigForm">
    <div class="settings-option" *ngIf="isUserDAEngineer">
      <div class="settings-option-title">value recognition</div>
      <div class="settings-option-action">
        <button
          class="adap-btn-blank btn-text"
          (click)="openValueRecognition()"
        >
          open legend
        </button>
      </div>
    </div>
    <app-global-settings-title-horizontal-line
      class="section-divider"
      text="email settings"
      [showExpansionIndicator]="true"
      [expanded]="showEmailSettings"
      (expansionClick)="changeExpansion('emailSettings')"
    ></app-global-settings-title-horizontal-line>
    <div class="email-settings-container" *ngIf="showEmailSettings">
      <div class="settings-option">
        <div class="settings-option-title">
          <app-slide-toggle
            [value]="!userConfigForm.controls.isEmailDisabled.value"
            (valueChange)="onSendEmailNotificationChange($event)"
          ></app-slide-toggle>
          <span class="hide-done-label">send email notifications</span>
        </div>
      </div>
      <div class="settings-option" *ngIf="hasUserGlobalAdminAccess$ | async">
        <div class="settings-option-title">send release email</div>
        <div class="settings-option-action">
          <button class="adap-btn-blank btn-text" [matMenuTriggerFor]="menu">
            open options
          </button>
          <mat-menu #menu>
            <button
              mat-menu-item
              *ngFor="let option of sendReleaseEmailOptions"
              (click)="onSendReleaseEmailOptionSelect(option)"
              [disabled]="option.disabled"
            >
              <span class="menu-name"> {{ option.text }}</span>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
    <app-global-settings-title-horizontal-line
      class="section-divider"
      text="default templates"
      [showExpansionIndicator]="true"
      [expanded]="showDefaultTemplates"
      (expansionClick)="changeExpansion('defaultTemplates')"
    ></app-global-settings-title-horizontal-line>
    <div class="default-templates-container" *ngIf="showDefaultTemplates">
      <div class="settings-option" *ngIf="isUserDAEngineer">
        <div class="settings-option-title">mandatory checks</div>
        <div class="settings-option-action">
          <a
            [routerLink]="[MANDATORY_CHECKS_TEMPLATES_ROUTE]"
            class="adap-link"
          >
            open templates
          </a>
        </div>
      </div>
      <div class="settings-option" *ngIf="hasUserGlobalAdminAccess$ | async">
        <div class="settings-option-title">business units</div>
        <div class="settings-option-action">
          <a [routerLink]="[BUSINESS_UNITS_ROUTE]" class="adap-link">
            open options
          </a>
        </div>
      </div>
      <div class="settings-option" *ngIf="isUserDAEngineer">
        <div class="settings-option-title">deliverable templates</div>
        <div class="settings-option-action">
          <a [routerLink]="[DELIVERABLE_TEMPLATES_ROUTE]" class="adap-link">
            open templates
          </a>
        </div>
      </div>
      <div class="settings-option" *ngIf="hasUserGlobalAdminAccess$ | async">
        <div class="settings-option-title">risk assessment</div>
        <div class="settings-option-action">
          <a [routerLink]="[RISK_ASSESSMENT_ROUTE]" class="adap-link">
            open risk assessment
          </a>
        </div>
      </div>
    </div>
    <app-global-settings-title-horizontal-line
      class="section-divider"
      text="user management"
      [showExpansionIndicator]="true"
      [expanded]="showUserManagement"
      (expansionClick)="changeExpansion('userManagement')"
    ></app-global-settings-title-horizontal-line>
    <div class="user-management-container" *ngIf="showUserManagement">
      <div class="settings-option" *ngIf="hasUserGlobalAdminAccess$ | async">
        <div class="settings-option-title">global admins</div>
        <div class="settings-option-action">
          <button
            class="adap-btn-blank btn-text"
            (click)="editGlobalAdminAccess()"
          >
            edit access
          </button>
        </div>
      </div>
      <div class="settings-option" *ngIf="isUserDAEngineer">
        <div class="settings-option-title">assignments</div>
        <div class="settings-option-action">
          <a [routerLink]="[ASSIGNMENTS_ROUTE]" class="adap-link">
            open assignments
          </a>
        </div>
      </div>
      <!-- Feature disabled: Exceptions
      This form allows adding users to an exception list to bypass "SharePoint PeerPool Filter" feature.
      Set *ngIf="hasUserGlobalAdminAccess$ | async" when "SharePoint PeerPool Filter" feature is also enabled.
      -->
      <div class="settings-option" *ngIf="false">
        <div class="settings-option-title">exceptions</div>
        <div class="settings-option-action">
          <button
            class="adap-btn-blank btn-text"
            (click)="editExceptionAccess()"
          >
            edit access
          </button>
        </div>
      </div>
      <div class="settings-option" *ngIf="hasUserGlobalAdminAccess$ | async">
        <div class="settings-option-title">peer pool disciplines</div>
        <div class="settings-option-action">
          <a [routerLink]="[PEER_POOL_DISCIPLINES_ROUTE]" class="adap-link">
            open disciplines
          </a>
        </div>
      </div>
      <div class="settings-option">
        <div class="settings-option-title">peer pool dashboard</div>
        <div class="settings-option-action">
          <button
            class="adap-btn-blank btn-text"
            (click)="openPeerPoolDashboard()"
          >
            open in Sharepoint
          </button>
        </div>
      </div>

      <iframe
        class="power-bi-dashboard"
        title="Design Assurance Peer Pool"
        width="100%"
        height="800"
        src="https://app.powerbi.com/reportEmbed?reportId=341052b5-cddb-474d-91a7-b43998b064bf&autoAuth=true&ctid=fd799da1-bfc1-4234-a91c-72b3a1cb9e26"
        frameborder="0"
        allowFullScreen="true"
      ></iframe>
    </div>
  </ng-container>
</div>
